import { formatPricePaisa } from "@/lib/format";

/**
 * What a product with no customer price shows instead of an amount: the
 * product page's wording. The search API sends `minPrice: null` for such a
 * product, and formatting that null printed "₹0", which reads as free.
 */
export const PRICE_ON_REQUEST = "Price on request";

/**
 * A search result's price as browse cards and the BOQ product search print it,
 * or null when the product has no customer price. A product whose variants are
 * priced differently shows its range.
 */
export function searchResultPriceLabel(product: {
	minPrice: number | null;
	maxPrice: number | null;
	hasVariants: boolean;
}): string | null {
	const { minPrice, maxPrice, hasVariants } = product;
	if (minPrice === null) return null;
	if (hasVariants && maxPrice !== null && maxPrice !== minPrice) {
		return `${formatPricePaisa(minPrice)} - ${formatPricePaisa(maxPrice)}`;
	}
	return formatPricePaisa(minPrice);
}
